import Banner from '../components/Banner';
import About from '../components/About';
import Services from '../components/Services';
import Contact from '../components/Contact';

const Index = () => {
  return (
    <>
      <Banner
        title="Bem-vindo(a)! É um prazer ter você aqui :)"
        subtitle="Este espaço foi pensado para compartilhar conhecimentos sobre alimentação saudável com práticas que promovem saúde e bem-estar."
        imgSrc="/assets/index/banner.png"
      />
      <About />
      <Services />
      <Contact />
    </>
  );
};

export default Index;
